import { render } from "./WebhookMonitor.vue?vue&type=template&id=44cd0fa0&scoped=true"
import script from "./WebhookMonitor.vue?vue&type=script&lang=ts"
export * from "./WebhookMonitor.vue?vue&type=script&lang=ts"

import "./WebhookMonitor.vue?vue&type=style&index=0&id=44cd0fa0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44cd0fa0"

export default script